import base from 'code/base_mixins'
//import {Program} from "../../models/program";
//import {Organization} from "../../models/organization";

export default {
  mixins: [base],
  data(){
    return {
      date_format: {
        long: "MMMM DD, YYYY"
      }
    }
  },
  computed:{
    current_organization(){
      return this.state.current_org
    },
  },
  methods: {
    get_available_spaces(obj){
      return (obj.spaces || Infinity) - (obj.registrations_count||0)
    },
    get_section_fee(display_fee_type, section_fee, currency){
      section_fee = parseFloat(section_fee)
      if (section_fee === 0.0){
        //return (display_fee_type === 'dollar') ? this.number_to_currency(section_fee, currency||"_") : I18n.t('app.program.payment.administrative_fee.no_fee')
        return (display_fee_type === 'dollar') ? this.number_to_currency(section_fee, currency||"_") : ''
      }else{
        return this.number_to_currency(section_fee, currency||"_")
      }
    },
    duration(from, to){
      const join_with = (I18n.locale === I18n.default_locale ? ' to ' : ' a ')
      let arr = []

      if (from) arr.push(I18n.toTime('date.formats.short',from))
      if (to)   arr.push(I18n.toTime('date.formats.short',to))
      return arr.join(join_with)
    },
    formatted_date(date){
      if (date) return date.format(this.date_format.long)
      return null
    },
    should_render_addon_form({registration, program}){
      if (program.owned_by(this.current_organization)) return true; //always render checkboxes for organization
      if (registration.preview)                        return true; //always render checkboxes for preview

      if (registration.isStillPending() && program.registration_open()) return true; //rendering checkboxes if program is open and reg is not yet completed
      return false
    },
    invalid_section_tooltip( age_invalid, grade_invalid){
      let title = ""
      if (age_invalid && grade_invalid) title = `${age_invalid}<br>${grade_invalid}`
      else title = age_invalid || grade_invalid || ''

      return `<span data-balloon-pos="up" aria-label='${title}'><span class='expired-field'></span></span>`
    },

    should_show_active_dates(obj){ // This is only for orgs use. API doesn't return inactive objects to families
      if (!obj.today_in_dates()) return true; // the obj is not in active dates. So it's greyed out and the active dates message is shown
      return this.state.current_reg.preview && (obj.valid_from || obj.valid_until) // if it's preview, we have active dates, and the obj is IN active dates, we are showing the dates.
    },
    can_cancel({registration: registration, program: program}) {
      return !(this.registration_open(program)) || !this.isCanceled(registration) && !this.is_online_payment_completed(registration)
    },
    isCanceled(registration){
      return ["canceled", "listed_canceled"].includes(registration.state)
    },
    registration_open(program){
      return program.render_registration_state==='open'
    },
    is_online_payment_completed(registration){
      if (registration.payments.length === 0){ return false }
      return registration.payments.some(payment => payment.provider_type !== "Offline")
    },
    sections_list(registration) {
      return registration.registration_sections.map(reg_section =>{
        const sec_name = this.section_name(reg_section)
        return `<span title=${sec_name}>${sec_name}<span>`
      }).join("<br>")
    },
    section_name(reg_section){
      try {
        return this.$sanitize(`${reg_section.section.name} (${this.time_from(reg_section.section.starts_at, "MMMM DD, YYYY")} - ${this.time_from(reg_section.section.ends_at, "MMMM DD, YYYY")})`)
      }catch{
        return "Section removed"
      }
    },
    choice_price(choice, parent_object, base_price, reg_obj=null) {
      if (choice.choice_type === 'custom' && reg_obj && reg_obj.other_amount) {
        choice.amount = parseFloat(reg_obj.other_amount[choice.id.toString()])
      }
      switch (parent_object.pricing_type) {
        case "no_price": return 0.0;
        case "fixed": return choice.amount;
        default: return parseFloat(base_price) * (parseFloat(choice.amount) / 100.0);
      }
    }
  }
}
